module.exports = __webpack_public_path__ + "img/declareTitleImg2.95aa8413.png";